import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const AmericanFootballIcon = observer(
    'AmericanFootballIcon',
    ({ className, onClick }: PropsType): JSX.Element => {
        return (
            <SvgElement
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='#061A32'
                className={className}
                onClick={onClick}
            >
                <path
                    d='M21.7743 8.53287C21.7908 8.40761 21.8068 8.28181 21.8215 8.15515C22.1769 5.10624 21.8941 2.72895 21.8819 2.62924L21.8261 2.17395L21.3708 2.11817C21.2711 2.10596 18.8939 1.82314 15.8449 2.1786C15.7182 2.19335 15.5925 2.20927 15.4672 2.22582L21.7743 8.53287Z'
                    fill='fill'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M14.041 2.45918C12.9284 2.6773 11.8826 2.971 10.9176 3.33819C9.05704 4.04607 7.48984 5.02886 6.25939 6.2593C5.02895 7.48971 4.04616 9.05695 3.33829 10.9175C2.9723 11.8794 2.67935 12.9215 2.46143 14.0299L9.97021 21.5387C11.0786 21.3208 12.1207 21.0278 13.0826 20.6618C14.9431 19.9539 16.5104 18.9712 17.7408 17.7407C18.9712 16.5103 19.954 14.9431 20.6619 13.0825C21.0291 12.1175 21.3228 11.0717 21.5409 9.95912L14.041 2.45918ZM7.34393 14.1182L8.19145 14.9657L9.82281 13.3343L8.97529 12.4868L9.80509 11.657L10.6526 12.5045L12.5046 10.6525L11.6571 9.805L12.4869 8.9752L13.3344 9.82272L15.1244 8.03274L14.2769 7.18522L15.1067 6.35541L17.6315 8.88026L16.8017 9.71006L15.9542 8.86254L14.1642 10.6525L15.0118 11.5L14.182 12.3298L13.3344 11.4823L11.4824 13.3343L12.3299 14.1819L11.5001 15.0117L10.6526 14.1641L9.02125 15.7955L9.86877 16.643L9.03897 17.4728L6.51417 14.948L7.34393 14.1182Z'
                    fill='fill'
                />
                <path
                    d='M2.17857 15.8448C2.19383 15.7142 2.21026 15.5846 2.22739 15.4555L8.54441 21.7725C8.41533 21.7897 8.28573 21.8061 8.15516 21.8213C6.98816 21.9574 5.91951 22 5.03936 22C3.62002 22 2.69078 21.8893 2.62925 21.8818L2.17396 21.826L2.11817 21.3707C2.10597 21.271 1.82315 18.8937 2.17857 15.8448Z'
                    fill='fill'
                />
            </SvgElement>
        );
    }
);
